(function () {
  function bindReveal() {
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('show');
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.fg-page .rv').forEach(function (el) {
      obs.observe(el);
    });
  }

  function init() {
    if (window.SALTARE_LANDING_PAGE_INIT) return;
    window.SALTARE_LANDING_PAGE_INIT = true;
    bindReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
